import { useSearchParams } from "react-router";

import { GradebookGrid } from "@/components/gradebook/GradebookGrid";

/**
 * The grades view of a registrar course record
 * (`/admin/courses/{courseId}?view=grades`, `&enrollment=` focuses a learner).
 *
 * The section's working gradebook with the administration's authority: override
 * an uncertified result, and certify or correct in the queue. Final submission
 * stays the instructor's. The tenant-wide letter-to-GPA scale is an institution
 * setting, not a property of one section, so it lives in Institution Settings.
 */
export function RegistrarCourseGrades({ courseId }: { courseId: string }) {
  const [searchParams] = useSearchParams();
  return (
    <GradebookGrid
      key={courseId}
      courseId={courseId}
      mode="admin"
      focusEnrollmentId={searchParams.get("enrollment")}
    />
  );
}
